import React,{Component} from "react";
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Input
} from "reactstrap";
import API from "api.js";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import {base} from "api.js";
import { NavLink } from "react-router-dom";
import ReactHtmlParser from 'react-html-parser';
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";

import { thead, tbody } from "variables/general";
import { setAlert} from 'action/index.js';
import {store} from 'store/index';
class QuestionComment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      commentData:[],
      comment:'',
      id:0,
      loaderFlag:false,
      loaderCommentFlag:false,
      scoreData:[]
    };
  }
  componentDidMount() {
    this.loadComment();
  }

  loadComment = () => {
    this.setState({loaderCommentFlag:true});
    var bodyFormData = new FormData();
    bodyFormData.set('question_id', this.props.question);
    //bodyFormData.set('skip', this.state.commentData.length);
    API({
      method: 'POST',
      url: 'show/comment',
      data:bodyFormData
    }).then(data => {
      if(data.status === 200){
        this.setState({commentData:[...this.state.commentData,...data.data.data],loaderCommentFlag:false});  
      }
    });
  }


  showHistoryFunc = () =>{
    let arr = this.state.commentData.map((v) => { if (this.state.id === v.id) {return v.score}  });
    let a =arr.filter((va)=> {if(typeof va === "object"){ return va;}})[0].map( (v) =>{ return(`<tr><td>${this.remarks(v.type)}</td><td>${v.score}/${v.from}</td><td>${v.remarks}</td></tr>` )} );
    return a;
  }

  addComent = async () => {
    this.setState({loaderFlag:true});
    var bodyFormData = new FormData();
    if(this.state.comment === ""){
      store.dispatch(setAlert({'flag':true,'type':2,'message':"Comment cant't be empty"}));
      return ""
    }
    bodyFormData.set('comment', this.state.comment);
    bodyFormData.set('question_id', this.props.question);
    let res = null;
    try{
      res = await API({
        method: 'POST',
        url: 'add/question/comment',
        data: bodyFormData,
      })
    }catch(error) {
        console.log(error);
    };
    
    if(res){
      if (res.status === 200) {
        this.setState({commentData:[...res.data.data,...this.state.commentData],comment:'',loaderFlag:false});
        store.dispatch(setAlert({'flag':true,'type':1,'message':res.data.message}));
      }
    }

  }


  changeComment = (e) => {
    let { name, value } = e.target;
    this.setState({ [name] : value });
  }

  deleteComment = (e,id) =>{
    confirmAlert({
      title: '',
      message: 'Are you sure you want to delete this record?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteCommentApi(e,id)
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  }

  deleteCommentApi = async (e,id) => {
    this.setState({loaderFlag:true});
    var bodyFormData = {'id':id,'question_id':this.props.question};
    let res = null;
    try{
      res = await API({
        method: 'Delete',
        url: 'delete/question/comment',
        data: bodyFormData
      })
    }catch(error) {
        //this.setState({error:{error} });
    };
    
    if(res){
      
      if (res.status === 200) {
        let commentData = this.state.commentData.filter((val)=> {if(parseInt(val.id) !== parseInt(id) ){ return val;}});
        this.setState({commentData:commentData,loaderFlag:false});
        store.dispatch(setAlert({'flag':true,'type':1,'message':res.data.message}));
      }
    }
  }

  render() {
    
    return (
      <>
          <Row>
          
            <Col xs={12}>
              <div>
                <CardBody>
                  <div class="videoComnts">
                    <div className="commentArea">
                        <Input type="textarea" className="commentText" name="comment" value={this.state.comment} onChange={(e) => (this.changeComment(e))}  />
                        {!this.state.loaderFlag && <Button color="primary" onClick={this.addComent}>Add Comment</Button>}
                        {this.state.loaderFlag && <Button color="primary" >Wait...</Button>}
                    </div>
                      <div className="postedComments">
                        {this.state.commentData.map((val, key) => {
                      
                          return (
                            <React.Fragment>
                            <div class="pComment">
                              <td>
                                <h3 className="comment-user text-center"><img style={{width: '57px',height: '57px',borderRadius:'41px'}} src={(val.user.image)?base+val.user.image:"data:image/jpeg;base64,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"} />&nbsp;{val.user.first_name}</h3>
                            
                              </td>
                              <td>
                                
                              {!this.state.loaderFlag && store.getState().user.id === val.user_id && <Button onClick={(e) => (this.deleteComment(e,val.id))} outline color="danger">Delete</Button>}
                              </td><br/>
                              <p style={{background:"white"}}>{val.comment}</p><br/>
                              <small>{val.aus_date +" (AEDT)"}</small>
                              <br/>
                              <hr/>
                            </div>
                            </React.Fragment>        
                          );
                        })}
                      </div>
                  </div>
                   
                   {this.state.loaderCommentFlag && <h3 className="text-center">Loading...</h3>}
                </CardBody>
              </div>
            </Col>
            
          </Row>
      
      </>
    );
  }
}

export default QuestionComment;
